const bedc = [
	'bedc:transaction:lookup',
	'bedc:transaction:lookup:{clientId}/files',

	'bedc:transaction:search',

	'bedc:transaction:list',
	'bedc:transaction:list:{clientId}/allCustomers',
	'bedc:transaction:list:{clientId}/targetAt',
	'bedc:transaction:list:{clientId}/owner',
	'bedc:transaction:list:{organizationId}/salesPerson',
	'bedc:transaction:list:{clientId}/assignedTo',
	'bedc:transaction:list:{clientId}/timeInStatusFrom',
	'bedc:transaction:list/fileProcessing',
	'bedc:transaction:list:{clientId}/folder/bedc:cat:in-progress',
	'bedc:transaction:list:{clientId}/folder/bedc:cat:chat',

	'bedc:transaction:read',
	'bedc:transaction:read:{clientId}',
	'bedc:transaction:read:{organizationId}/unallocated',
	'bedc:transaction:read:{clientId}/timeSpent',
	'bedc:transaction:read:{clientId}/team',
	'bedc:transaction:read:{organizationId}/salesPerson',
	'bedc:transaction:read:{clientId}/previewFiles',
	'bedc:transaction:read:{clientId}/targetAt',
	'bedc:transaction:read:{clientId}/files',
	'bedc:transaction:read:{clientId}/file/bedc:cat:in-progress',
	'bedc:transaction:read:{clientId}/file/bedc:cat:chat',
	'bedc:transaction:read:{clientId}/file/bedc:cat:archived',
	'bedc:transaction:read:{clientId}/folders',
	'bedc:transaction:read:{clientId}/folder/bedc:cat:in-progress',
	'bedc:transaction:read:{clientId}/folder/bedc:cat:chat',
	'bedc:transaction:read:{clientId}/folder/bedc:cat:saas-accounting',
	'bedc:transaction:read:{clientId}/folder/bedc:cat:saas-estimator',
	'bedc:transaction:read:{clientId}/folder/bedc:cat:saas-only',
	'bedc:transaction:read:{clientId}/form/details',
	'bedc:transaction:read:{clientId}/form/difficulty',
	'bedc:transaction:read:{clientId}/form/difficulty-org',
	'bedc:transaction:read:{clientId}/form/volumetrics',
	'bedc:transaction:read:{clientId}/form/review',
	'bedc:transaction:read:{clientId}/form/whole-house',
	'bedc:transaction:read:{clientId}/form/ai-feedback',
	'bedc:transaction:read:{clientId}/form/late-work-survey',
	'bedc:transaction:read:{clientId}/chat/internal',
	'bedc:transaction:read:{clientId}/chat/external',
	'bedc:transaction:read:{clientId}/chat/review-form/item',
	'bedc:transaction:read:{clientId}/chat/woh/canvas',
	'bedc:transaction:read:{clientId}/chat/woh/canvas/bom/item',
	'bedc:transaction:read:{clientId}/activityLog',
	'bedc:transaction:read:{clientId}/activityLog/category:admin',
	'bedc:transaction:read:{clientId}/activityLog/category:internal',
	'bedc:transaction:read:{clientId}/activityLog/category:client',
	'bedc:transaction:read:{clientId}/integration/link',
	//
	'bedc:transaction:read:{clientId}/stages',
	'bedc:transaction:read:{organizationId}/stages/unAllocated',
	'bedc:transaction:read:{clientId}/activeStages',
	'bedc:transaction:read:{clientId}/stage/preprocess',
	'bedc:transaction:read:{clientId}/stage/fps',
	'bedc:transaction:read:{clientId}/stage/fps/byFeatureFlag/client-fps',
	'bedc:transaction:read:{clientId}/stage/jrf',
	'bedc:transaction:read:{clientId}/stage/hitl',
	'bedc:transaction:read:{clientId}/stage/trussHitl',
	'bedc:transaction:read:{clientId}/stage/aiFrame',
	'bedc:transaction:read:{clientId}/stage/wholeHouse',
	'bedc:transaction:read:{clientId}/stage/design',
	'bedc:transaction:read:{organizationId}/stage/design/unAllocated',
	'bedc:transaction:read:{clientId}/stage/tlReview',
	'bedc:transaction:read:{clientId}/stage/qaReview',
	'bedc:transaction:read:{clientId}/stage/designSimple',
	'bedc:transaction:read:{organizationId}/stage/designSimple/unAllocated',
	'bedc:transaction:read:{clientId}/stage/fileProcessing',
	'bedc:transaction:read:{organizationId}/stage/sealing',
	'bedc:transaction:read:{organizationId}/stage/pricing',
	'bedc:transaction:read:{organizationId}/stage/estimateManagement',
	'bedc:transaction:read:{organizationId}/stage/accountingReview',
	'bedc:transaction:read:{organizationId}/stage/invoicing',
	'bedc:transaction:read:{organizationId}/stage/delivery',
	'bedc:transaction:read:{organizationId}/stage/orderManagement',
	'bedc:transaction:read:{organizationId}/stage/production',
	'bedc:transaction:read:{organizationId}/stage/staging',
	'bedc:transaction:read:{organizationId}/stage/managementReview',

	'bedc:transaction:create',
	'bedc:transaction:create:{clientId}/file',
	'bedc:transaction:create:{clientId}/file/bedc:category:completed',
	'bedc:transaction:create:{clientId}/folder',
	'bedc:transaction:create:{clientId}/form/review/item',

	'bedc:transaction:update',
	'bedc:transaction:update:{organizationId}/allocate',
	'bedc:transaction:update:{clientId}/cancel',
	'bedc:transaction:update:{clientId}/cancel/inProgress',
	'bedc:transaction:update:{clientId}/hold',
	'bedc:transaction:update:{clientId}/removeHold',
	'bedc:transaction:update:{clientId}/pendingFeedback',
	'bedc:transaction:update:{clientId}/rework',
	'bedc:transaction:update:{organizationId}/duplicate',
	'bedc:transaction:update:{clientId}/owner',
	'bedc:transaction:update:{clientId}/owner/estimator',
	'bedc:transaction:update:{clientId}/owner/saas-estimator',
	'bedc:transaction:update:{clientId}/teamLeader',
	'bedc:transaction:update:{clientId}/qaPerson',
	'bedc:transaction:update:{clientId}/targetAt',
	'bedc:transaction:update:{clientId}/chat/internal',
	'bedc:transaction:update:{clientId}/chat/external',
	'bedc:transaction:update:{clientId}/chat/review-form/item',
	'bedc:transaction:update:{clientId}/chat/woh/canvas/bom/item',
	'bedc:transaction:update:{clientId}/chat/woh/canvas',
	'bedc:transaction:update:{clientId}/form/details',
	'bedc:transaction:update:{clientId}/form/details/requirements',
	'bedc:transaction:update:{clientId}/form/details/ancillaryItems',
	'bedc:transaction:update:{organizationId}/unallocated/form/details',
	'bedc:transaction:update:{clientId}/form/difficulty',
	'bedc:transaction:update:{clientId}/form/difficulty/complete',
	'bedc:transaction:update:{clientId}/form/difficulty-org',
	'bedc:transaction:update:{clientId}/form/volumetrics',
	'bedc:transaction:update:{clientId}/form/volumetrics/postDesignCompleted',
	'bedc:transaction:update:{clientId}/form/review',
	'bedc:transaction:update:{clientId}/form/review/item',
	'bedc:transaction:update:{clientId}/form/ai-feedback',
	'bedc:transaction:update:{clientId}/form/late-work-survey',
	'bedc:transaction:update:{clientId}/form/whole-house/canvas',
	'bedc:transaction:update:{clientId}/file/archive',
	'bedc:transaction:update:{clientId}/file/label',
	'bedc:transaction:update:{clientId}/file/parentFolderId',
	'bedc:transaction:update:{clientId}/file/version',
	'bedc:transaction:update:{clientId}/folder/name',
	'bedc:transaction:update:{clientId}/folder/parentFolderId',
	//
	'bedc:transaction:update:{clientId}/assignee',
	'bedc:transaction:update:{clientId}/status',
	'bedc:transaction:update:{clientId}/timer/start',
	'bedc:transaction:update:{clientId}/timer/pause',
	'bedc:transaction:update:{clientId}/stage/preprocess',
	'bedc:transaction:update:{clientId}/stage/fps',
	'bedc:transaction:update:{clientId}/stage/jrf',
	'bedc:transaction:update:{clientId}/stage/hitl',
	'bedc:transaction:update:{clientId}/stage/trussHitl',
	'bedc:transaction:update:{clientId}/stage/aiFrame',
	'bedc:transaction:update:{clientId}/stage/wholeHouse',
	'bedc:transaction:update:{clientId}/stage/design',
	'bedc:transaction:update:{clientId}/stage/design/postCompleteStatuses',
	'bedc:transaction:update:{clientId}/stage/tlReview',
	'bedc:transaction:update:{clientId}/stage/qaReview',
	'bedc:transaction:update:{clientId}/stage/designSimple',
	'bedc:transaction:update:{clientId}/stage/fileProcessing',
	'bedc:transaction:update:{clientId}/stage/sealing',
	'bedc:transaction:update:{clientId}/stage/pricing',
	'bedc:transaction:update:{clientId}/stage/estimateManagement',
	'bedc:transaction:update:{clientId}/stage/accountingReview',
	'bedc:transaction:update:{clientId}/stage/invoicing',
	'bedc:transaction:update:{clientId}/stage/delivery',
	'bedc:transaction:update:{clientId}/stage/orderManagement',
	'bedc:transaction:update:{clientId}/stage/production',
	'bedc:transaction:update:{clientId}/stage/staging',
	'bedc:transaction:update:{clientId}/stage/managementReview',
	'bedc:transaction:update:{clientId}/integration/link',

	'bedc:transaction:bulkupdate/timer',
	'bedc:transaction:bulkupdate:{clientId}/owner',
	'bedc:transaction:bulkupdate:{clientId}/teamLeader',
	'bedc:transaction:bulkupdate:{clientId}/qaPerson',
	'bedc:transaction:{organizationId}/bulkupdate',

	'bedc:transaction:delete:{organizationId}/unallocated',
	'bedc:transaction:delete:{clientId}',
	'bedc:transaction:delete:{clientId}/inProgress',
	'bedc:transaction:delete:{clientId}/file',
	'bedc:transaction:delete:{clientId}/file/supplied-files',
	'bedc:transaction:delete:{clientId}/form/review/item',
	'bedc:transaction:delete:{clientId}/folder',
] as const;

const integration = ['integration:transaction:read:{organizationId}/file'] as const;

export default [...bedc, ...integration] as const;
